/* eslint max-nested-callbacks: ["error", 8] */
'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('ipld-dag-pb'),
    DAGNode = _require.DAGNode,
    DAGLink = _require.DAGLink;

var CID = require('cids');

var _require2 = require('p-queue'),
    Queue = _require2.default;

var _require3 = require('interface-datastore'),
    Key = _require3.Key;

var errCode = require('err-code');

var multicodec = require('multicodec');

var dagCborLinks = require('dag-cbor-links');

var debug = require('debug');

var _require4 = require('buffer'),
    Buffer = _require4.Buffer;

var _require5 = require('../../../utils/cid'),
    cidToString = _require5.cidToString;

var createPinSet = require('./pin-set');

var _require6 = require('interface-datastore'),
    Errors = _require6.Errors;

var ERR_NOT_FOUND = Errors.notFoundError().code; // arbitrary limit to the number of concurrent dag operations

var WALK_DAG_CONCURRENCY_LIMIT = 300;
var IS_PINNED_WITH_TYPE_CONCURRENCY_LIMIT = 300;
var PIN_DS_KEY = new Key('/local/pins');

function invalidPinTypeErr(type) {
  var errMsg = "Invalid type '".concat(type, "', must be one of {direct, indirect, recursive, all}");
  return errCode(new Error(errMsg), 'ERR_INVALID_PIN_TYPE');
}

var PinTypes = {
  direct: 'direct',
  recursive: 'recursive',
  indirect: 'indirect',
  all: 'all'
};

var PinManager = /*#__PURE__*/function () {
  function PinManager(repo, dag) {
    _classCallCheck(this, PinManager);

    this.repo = repo;
    this.dag = dag;
    this.log = debug('ipfs:pin');
    this.pinset = createPinSet(dag);
    this.directPins = new Set();
    this.recursivePins = new Set();
  }

  _createClass(PinManager, [{
    key: "_walkDag",
    value: function () {
      var _walkDag2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
        var _this = this;

        var cid, _ref$preload, preload, _ref$onCid, onCid, walk, queue;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                cid = _ref.cid, _ref$preload = _ref.preload, preload = _ref$preload === void 0 ? false : _ref$preload, _ref$onCid = _ref.onCid, onCid = _ref$onCid === void 0 ? function () {} : _ref$onCid;

                if (!CID.isCID(cid)) {
                  cid = new CID(cid);
                }

                walk = function walk(cid) {
                  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var _yield$_this$dag$get, node, _iterator, _step, _step$value, _, childCid;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return _this.dag.get(cid, {
                              preload: preload
                            });

                          case 2:
                            _yield$_this$dag$get = _context.sent;
                            node = _yield$_this$dag$get.value;
                            onCid(cid);

                            if (cid.codec === 'dag-pb') {
                              queue.addAll(node.Links.map(function (link) {
                                return walk(link.Hash);
                              }));
                            } else if (cid.codec === 'dag-cbor') {
                              _iterator = _createForOfIteratorHelper(dagCborLinks(node));

                              try {
                                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                                  _step$value = _slicedToArray(_step.value, 2), _ = _step$value[0], childCid = _step$value[1];
                                  // eslint-disable-line no-unused-vars
                                  queue.add(walk(childCid));
                                }
                              } catch (err) {
                                _iterator.e(err);
                              } finally {
                                _iterator.f();
                              }
                            }

                          case 6:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));
                };

                queue = new Queue({
                  concurrency: WALK_DAG_CONCURRENCY_LIMIT
                });
                queue.add(walk(cid));
                _context2.next = 7;
                return queue.onIdle();

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function _walkDag(_x) {
        return _walkDag2.apply(this, arguments);
      }

      return _walkDag;
    }()
  }, {
    key: "directKeys",
    value: function directKeys() {
      return Array.from(this.directPins, function (key) {
        return new CID(key).buffer;
      });
    }
  }, {
    key: "recursiveKeys",
    value: function recursiveKeys() {
      return Array.from(this.recursivePins, function (key) {
        return new CID(key).buffer;
      });
    }
  }, {
    key: "getIndirectKeys",
    value: function () {
      var _getIndirectKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
        var _this2 = this;

        var preload, indirectKeys, _iterator2, _step2, multihash;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                preload = _ref3.preload;
                indirectKeys = new Set();
                _iterator2 = _createForOfIteratorHelper(this.recursiveKeys());
                _context3.prev = 3;

                _iterator2.s();

              case 5:
                if ((_step2 = _iterator2.n()).done) {
                  _context3.next = 11;
                  break;
                }

                multihash = _step2.value;
                _context3.next = 9;
                return this._walkDag({
                  cid: new CID(multihash),
                  preload: preload || false,
                  onCid: function onCid(cid) {
                    cid = cid.toString(); // recursive pins pre-empt indirect pins

                    if (!_this2.recursivePins.has(cid)) {
                      indirectKeys.add(cid);
                    }
                  }
                });

              case 9:
                _context3.next = 5;
                break;

              case 11:
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](3);

                _iterator2.e(_context3.t0);

              case 16:
                _context3.prev = 16;

                _iterator2.f();

                return _context3.finish(16);

              case 19:
                return _context3.abrupt("return", Array.from(indirectKeys));

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 13, 16, 19]]);
      }));

      function getIndirectKeys(_x2) {
        return _getIndirectKeys.apply(this, arguments);
      }

      return getIndirectKeys;
    }() // Encode and write pin key sets to the datastore:
    // a DAGLink for each of the recursive and direct pinsets
    // a DAGNode holding those as DAGLinks, a kind of root pin

  }, {
    key: "flushPins",
    value: function () {
      var _flushPins = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _yield$Promise$all, _yield$Promise$all2, dLink, rLink, rootNode, rootCid;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Promise.all([// create a DAGLink to the node with direct pins
                this.pinset.storeSet(this.directKeys()).then(function (result) {
                  return new DAGLink(PinTypes.direct, result.node.size, result.cid);
                }), // create a DAGLink to the node with recursive pins
                this.pinset.storeSet(this.recursiveKeys()).then(function (result) {
                  return new DAGLink(PinTypes.recursive, result.node.size, result.cid);
                }), // the pin-set nodes link to a special 'empty' node, so make sure it exists
                this.dag.put(new DAGNode(Buffer.alloc(0)), {
                  version: 0,
                  format: multicodec.DAG_PB,
                  hashAlg: multicodec.SHA2_256,
                  preload: false
                })]);

              case 2:
                _yield$Promise$all = _context4.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                dLink = _yield$Promise$all2[0];
                rLink = _yield$Promise$all2[1];
                // create a root node with DAGLinks to the direct and recursive DAGs
                rootNode = new DAGNode(Buffer.alloc(0), [dLink, rLink]);
                _context4.next = 9;
                return this.dag.put(rootNode, {
                  version: 0,
                  format: multicodec.DAG_PB,
                  hashAlg: multicodec.SHA2_256,
                  preload: false
                });

              case 9:
                rootCid = _context4.sent;
                _context4.next = 12;
                return this.repo.datastore.put(PIN_DS_KEY, rootCid.buffer);

              case 12:
                this.log("Flushed pins with root: ".concat(rootCid));

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function flushPins() {
        return _flushPins.apply(this, arguments);
      }

      return flushPins;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var has, mh, pinRoot, _yield$Promise$all3, _yield$Promise$all4, rKeys, dKeys;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.repo.datastore.has(PIN_DS_KEY);

              case 2:
                has = _context5.sent;

                if (has) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return");

              case 5:
                _context5.next = 7;
                return this.repo.datastore.get(PIN_DS_KEY);

              case 7:
                mh = _context5.sent;
                _context5.next = 10;
                return this.dag.get(new CID(mh), '', {
                  preload: false
                });

              case 10:
                pinRoot = _context5.sent;
                _context5.next = 13;
                return Promise.all([this.pinset.loadSet(pinRoot.value, PinTypes.recursive), this.pinset.loadSet(pinRoot.value, PinTypes.direct)]);

              case 13:
                _yield$Promise$all3 = _context5.sent;
                _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
                rKeys = _yield$Promise$all4[0];
                dKeys = _yield$Promise$all4[1];
                this.directPins = new Set(dKeys.map(function (k) {
                  return cidToString(k);
                }));
                this.recursivePins = new Set(rKeys.map(function (k) {
                  return cidToString(k);
                }));
                this.log('Loaded pins from the datastore');

              case 20:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function load() {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "isPinnedWithType",
    value: function () {
      var _isPinnedWithType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(multihash, type) {
        var _this3 = this;

        var key, recursive, direct, all, queue, cid;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                key = cidToString(multihash);
                recursive = PinTypes.recursive, direct = PinTypes.direct, all = PinTypes.all; // recursive

                if (!((type === recursive || type === all) && this.recursivePins.has(key))) {
                  _context7.next = 4;
                  break;
                }

                return _context7.abrupt("return", {
                  key: key,
                  pinned: true,
                  reason: recursive
                });

              case 4:
                if (!(type === recursive)) {
                  _context7.next = 6;
                  break;
                }

                return _context7.abrupt("return", {
                  key: key,
                  pinned: false
                });

              case 6:
                if (!((type === direct || type === all) && this.directPins.has(key))) {
                  _context7.next = 8;
                  break;
                }

                return _context7.abrupt("return", {
                  key: key,
                  pinned: true,
                  reason: direct
                });

              case 8:
                if (!(type === direct)) {
                  _context7.next = 10;
                  break;
                }

                return _context7.abrupt("return", {
                  key: key,
                  pinned: false
                });

              case 10:
                // indirect (default)
                // check each recursive key to see if multihash is under it
                // arbitrary limit, enables handling 1000s of pins.
                queue = new Queue({
                  concurrency: IS_PINNED_WITH_TYPE_CONCURRENCY_LIMIT
                });
                queue.addAll(this.recursiveKeys().map(function (childKey) {
                  childKey = new CID(childKey);
                  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                    var has;
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return _this3.pinset.hasDescendant(childKey, key);

                          case 2:
                            has = _context6.sent;

                            if (has) {
                              cid = childKey;
                              queue.clear();
                            }

                          case 4:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));
                }));
                _context7.next = 14;
                return queue.onIdle();

              case 14:
                return _context7.abrupt("return", {
                  key: key,
                  pinned: Boolean(cid),
                  reason: cid
                });

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function isPinnedWithType(_x3, _x4) {
        return _isPinnedWithType.apply(this, arguments);
      }

      return isPinnedWithType;
    }() // Gets CIDs of blocks used internally by the pinner

  }, {
    key: "getInternalBlocks",
    value: function () {
      var _getInternalBlocks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var mh, cid, obj, cids;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return this.repo.datastore.get(PIN_DS_KEY);

              case 3:
                mh = _context8.sent;
                _context8.next = 12;
                break;

              case 6:
                _context8.prev = 6;
                _context8.t0 = _context8["catch"](0);

                if (!(_context8.t0.code === ERR_NOT_FOUND)) {
                  _context8.next = 11;
                  break;
                }

                this.log('No pinned blocks');
                return _context8.abrupt("return", []);

              case 11:
                throw new Error("Could not get pin sets root from datastore: ".concat(_context8.t0.message));

              case 12:
                cid = new CID(mh);
                _context8.next = 15;
                return this.dag.get(cid, '', {
                  preload: false
                });

              case 15:
                obj = _context8.sent;
                _context8.next = 18;
                return this.pinset.getInternalCids(obj.value);

              case 18:
                cids = _context8.sent;
                return _context8.abrupt("return", cids.concat(cid));

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 6]]);
      }));

      function getInternalBlocks() {
        return _getInternalBlocks.apply(this, arguments);
      }

      return getInternalBlocks;
    }()
  }, {
    key: "fetchCompleteDag",
    value: function () {
      var _fetchCompleteDag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(cid, options) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._walkDag({
                  cid: cid,
                  preload: options.preload
                });

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function fetchCompleteDag(_x5, _x6) {
        return _fetchCompleteDag.apply(this, arguments);
      }

      return fetchCompleteDag;
    }() // Returns an error if the pin type is invalid

  }], [{
    key: "checkPinType",
    value: function checkPinType(type) {
      if (typeof type !== 'string' || !Object.keys(PinTypes).includes(type)) {
        return invalidPinTypeErr(type);
      }
    }
  }]);

  return PinManager;
}();

PinManager.PinTypes = PinTypes;
module.exports = PinManager;